import { Button, Text } from 'grommet';
import { Delete } from './Delete';

export type BulkDeleteButtonProps = {
  /** How many items are checked; the button shows only once there's one */
  count: number;
  /** "role" / "roles", for "Delete 2 roles" */
  singular: string;
  plural: string;
  /** For the confirmation: "Are you sure you want to delete {names}?" */
  names?: string;
  onDelete: () => Promise<void> | void;
  /** false when the caller asks for confirmation itself (onDelete opens its own dialog) */
  confirm?: boolean;
};

/** "Delete 2 roles": shown beside a list's add button once something in it is checked */
export const BulkDeleteButton = ({
  count,
  singular,
  plural,
  names,
  onDelete,
  confirm = true,
}: BulkDeleteButtonProps) => {
  if (count === 0) return null;

  const props = {
    secondary: true,
    color: 'border-danger',
    style: { padding: '5px 14px', borderRadius: '18px', whiteSpace: 'nowrap', flexShrink: 0 } as const,
    label: (
      <Text size="small" weight={600} color="text-danger">
        Delete {count} {count === 1 ? singular : plural}
      </Text>
    ),
  };

  return confirm ? (
    <Delete onClick={() => onDelete()} name={names || `these ${plural}`} icon={null} {...props} />
  ) : (
    <Button onClick={() => onDelete()} {...props} />
  );
};
